<template>
	<div :class="{ box: true, flex: true, bg }">
		<div class="left">
			<img :src="item.product_pic" alt="" />
		</div>
		<div class="right fz-14 ml-10">
			<p class="ellipsis" style="color: #1D2129;max-width: 376px;">{{ item.product_name }}</p>
			<p class="yx-color-blue-6 fz-12 mt-4">商品ID：{{ item.third_product_id }}</p>
			<p style="color: #1D2129;" class="mt-6">
				<span>佣金率：{{ item.commission_rate }}%</span>
				<span class="ml-28" v-if="$isDy(item.platform_id) && item.commission_rate_during_the && item.commission_rate_during_the != 0">投放期佣金率：{{ item.commission_rate_during_the }}%</span>
				<span class="ml-28">直播价：¥{{ item.live_price }}</span>
			</p>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		bg: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
.box {
	border-radius: 2px;
	.left {
		width: 64px;
		height: 64px;
	}
}
.bg {
	background-color: #f7f8fa;
	padding: 16px;
}
</style>
